import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { DatabricksWorkspaceField } from './DatabricksWorkspaceField';

export const DatabricksWorkspaceFieldExtension = FormFieldBlueprint.make({
  name: 'databricks-workspace-field',
  params: {
    field: async () =>
      createFormField({
        name: 'DatabricksWorkspaceField',
        component: DatabricksWorkspaceField,
      }),
  },
});
